<span>
    <a [href]="'tel:' + formattedNumber">{{phone?.fullNumber}}</a>
</span>
